export function formatDate(dateInput?: Date | string | null): string {
    if (!dateInput) return "-";
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (Number.isNaN(date.getTime())) return "-";
    const yearFull = date.getFullYear();
    if (yearFull < 2000 || yearFull > 2050) return "-";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(yearFull).slice(-2);
    return `${day}.${month}.${year}`;
}

export function startOfIsoWeek(d: Date): Date {
    const x = new Date(d);
    x.setHours(12, 0, 0, 0);
    const day = x.getDay(); // 0=Sun..6=Sat
    const diff = day === 0 ? -6 : 1 - day;
    x.setDate(x.getDate() + diff);
    return x;
}

export function addDays(d: Date, days: number): Date {
    const x = new Date(d);
    x.setDate(x.getDate() + days);
    return x;
}

export function addWeeks(d: Date, weeks: number): Date {
    return addDays(d, weeks * 7);
}

/** react-datepicker getDay(): 0..6 (Вс..Сб), наш DOW: 1..7 (Пн..Вс) */
export function toDatePickerDow(templateDow: number): number {
    return templateDow === 7 ? 0 : templateDow;
}

export function filterOnlyDow(date: Date, allowedPickerDow: number): boolean {
    return date.getDay() === allowedPickerDow;
}

export function nextDateWithDow(from: Date, allowedPickerDow: number, searchDays = 21): Date | null {
    const d = new Date(from);
    d.setHours(12, 0, 0, 0);
    for (let i = 0; i < searchDays; i++) {
        if (d.getDay() === allowedPickerDow) return new Date(d);
        d.setDate(d.getDate() + 1);
    }
    return null;
}
